import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { getHeadingLevel } from 'lib/utils/getHeadingLevel';
import useExperienceEditor from 'lib/utils/use-experience-editor';
import { Foundation } from 'src/.generated/Foundation.EnterpriseWeb.model';
import classNames from 'classnames';
import { useTheme } from 'lib/context/ThemeContext';
import { applySuperscripts } from 'src/helpers/Superscripts/superscript';

export type HeadlineProps = Foundation.EnterpriseWeb.Enterprise.FieldSets.Headline & {
  useTag?: string;
  classes?: string;
};

const Headline = ({ fields, useTag, classes }: HeadlineProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const defaultTag = 'h2';
  const tag = useTag ?? getHeadingLevel(defaultTag, fields?.headlineLevel);

  const { themeName } = useTheme();
  const isRbaTheme = themeName === 'rba';
  const raw = fields?.headlineText?.value ?? '';

  if (!raw && !isEE) {
    return <></>;
  }

  if (!classes) {
    const baseClasses = 'text-theme-text text-sm-m md:text-m mb-s';
    const fontWeightClass = isRbaTheme && tag === 'h2' ? 'font-medium' : 'font-bold';
    classes = classNames(baseClasses, fontWeightClass);
  }
  // RBA: process superscripts | AW: use raw text
  const valueToRender = isRbaTheme ? applySuperscripts(raw) : raw;

  const headlineField = { value: valueToRender };

  return (
    <div className={classNames(`items-top font-sans [&_a:hover]:underline`, classes)}>
      <RichText tag={tag} field={headlineField} />
    </div>
  );
};
export default Headline;
